import img1 from './img/10001.jpeg'
import img2 from './img/10008.jpeg'
import img3 from './img/10003.jpeg'
import img4 from './img/10004.jpeg'
import img5 from './img/10006.jpeg'


export const img = [img1,img2,img3,img4,img5]